import { render } from "./Page15.vue?vue&type=template&id=08c2674d"
import script from "./Page15.vue?vue&type=script&lang=js"
export * from "./Page15.vue?vue&type=script&lang=js"

import "./Page15.vue?vue&type=style&index=0&id=08c2674d&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__